<h1 i18n>Cookie Settings</h1>
<p i18n>Are you ok with optional cookies? They let us give you a better experience, improve our products, and assist in our marketing efforts.</p>
<p><a routerLink="/cookie-policy" i18n>View our Cookie Policy for more information.</a></p>

<div class="button-panel" style="margin-bottom: 16px">
  <button 
  mat-raised-button
  (click)="accept()" 
  color="accent"
  i18n>ACCEPT</button>
 
  <button 
    mat-stroked-button
    (click)="deny()"
    i18n>DENY</button>
    
</div>
